import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import AuditTrailUserCriteria from "./AuditTrailUserCriteria";

@NeoReport("AuditTrailUserReport", { category: ReportCategory.SystemReports })
export default class AuditTrailUserReport extends Report<AuditTrailUserCriteria> {

    constructor() {
        super(AuditTrailUserCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
        </div>;
    }
}